// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-content-container-tvjsc {
  flex: 1;
  padding: 0px 20px;
  overflow: auto;
}
`, "",{"version":3,"sources":["webpack://./../core/src/components/modal-content/modal-content.module.css"],"names":[],"mappings":"AAAA;EACE,OAAO;EACP,iBAAiB;EACjB,cAAc;AAChB","sourcesContent":[".container {\n  flex: 1;\n  padding: 0px 20px;\n  overflow: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `modal-content-container-tvjsc`
};
export default ___CSS_LOADER_EXPORT___;
